import React from 'react';
import Icon from '../../../components/AppIcon';

const PopularBadge = () => {
  return (
    <div className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-accent/10 text-accent-foreground">
      <Icon name="TrendingUp" size={14} color="var(--color-accent)" />
      <span className="text-xs font-semibold">Popular</span>
    </div>
  );
};

export default PopularBadge;